<div class="audio-modes-menu flex flex-column">
  <div class="audio-modes-container m-b-8 p-8">
    <div class="flex items-center">
      <div class="audio-modes-wrapper">
        <span class="title m-b-10">audience mode</span>
        <div class="presets-grid">
          @for (preset of presets; track trackPresetByFn($index, preset)) {
            <div
              (click)="selectPreset(preset)"
              class="preset-container flex flex-column justify-center items-center"
              [class.selected]="presetSelected?.text === preset.text"
            >
              <img [src]="preset.icon" [alt]="preset.text" class="preset-icon m-b-8" />
              <span class="preset-text">{{ preset.text }}</span>
            </div>
          }
        </div>
      </div>
    </div>
    <app-advanced-presentation-settings
      [allowGroupConversations]="groupConversationsV1 ? false : settingsFormState?.allowGroupConversations"
      [defaultFullScreen]="settingsFormState?.defaultFullScreen"
      [interactionMode]="settingsFormState?.interactionMode"
      [requireFullScreen]="settingsFormState?.requireFullScreen"
      (changeEvent)="handleAdvancedSettingChange($event)"
    ></app-advanced-presentation-settings>
  </div>
  <div class="footer flex justify-center">
    <button mat-button class="save-btn m-t-16" [disabled]="!dirty" (click)="submit()">Save</button>
  </div>
</div>
